// Filter tools: https://stackoverflow.com/a/58110124/1202385
export const nonNullable = <T>(value: T): value is NonNullable<T> =>
  value !== null && value !== undefined

type Truthy<T> = T extends false | "" | 0 | null | undefined ? never : T // from lodash
export const truthy = <T>(value: T): value is Truthy<T> => !!value
